import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'patternlib-image',
  styleUrl: 'patternlib-image.scss',
  shadow: true,
})
export class PatternlibImage {
  /**
   * Set the image src.
   */
  @Prop({ reflect: true }) src: string;

  /**
   * Set the image description.
   */
  @Prop({ reflect: true }) alt: string;

  /**
   * Set the image width.
   */
  @Prop() width = 'auto';

  /**
   * Set the image max-width.
   */
  @Prop() maxWidth = '100%';

  /**
   * Set the image height.
   */
  @Prop() height = 'auto';

  /**
   * Define the object-fit property.
   */
  @Prop() objectFit: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down' | 'initial' | 'inherit' = 'cover';

  render() {
    const hostStyles = { height: this.height, width: this.width };
    const imageStyles = { objectFit: this.objectFit, width: this.width, height: this.height, maxWidth: this.maxWidth };

    return (
      <Host style={hostStyles}>
        <img src={this.src} alt={this.alt} style={imageStyles}></img>
      </Host>
    );
  }
}
